import api from '@shared/services/api.js';
const baseApi = '/company/api';
const baseUserUrl = `${baseApi}/users`;

export const getMember = id => {
  return api.get(`/company/api/users/${id}/`);
};

export const removeMember = id => {
  return api.delete(`${baseUserUrl}/${id}/`);
};

export const resetPassword = id => {
  return api.post(`${baseUserUrl}/${id}/reset_password/`);
};

export const updateUserRoles = async (userId, roles) => {
  return api.patch(`${baseUserUrl}/${userId}/`, { roles });
};

export const getMembers = (
  pageNumber = 1,
  pageSize = 25,
  sortBy = null,
  sortDesc = false,
  search = null,
) => {
  const url = api.constructUrl(`${baseUserUrl}/`, {
    page: pageNumber,
    page_size: pageSize,
    sort_by: sortBy,
    sort_desc: sortDesc,
    search: search || null,
  });
  return api.get(url);
};
